import React from "react"
import { TooltipWithBounds, defaultStyles } from "@visx/tooltip"
import { TOOLTIP_STYLE } from "../theme"

type ChartTooltipProps = {
    top: number
    left: number
    children: React.ReactNode
}

/**
 * Reusable glass-morphism tooltip wrapper for all charts.
 * Applies a 10px upward and 10px rightward offset from the cursor position.
 *
 * Usage:
 *   <ChartTooltip top={tooltipTop} left={tooltipLeft}>
 *     <div>Content here</div>
 *   </ChartTooltip>
 */
export const ChartTooltip = ({ top, left, children }: ChartTooltipProps) => (
    <TooltipWithBounds
        top={top - 10}
        left={left + 10}
        style={{ ...defaultStyles, ...TOOLTIP_STYLE }}
    >
        {children}
    </TooltipWithBounds>
)
